import React from 'react';

import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import CreateAdditionalInformation from './CreateAdditionalInformation';

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.booking.list,
  height: '100%',
  padding: '2rem 1rem 1rem 1rem',
  overflow: 'auto',

  [theme.breakpoints.up('xs')]: {
    height: 'max-content'
  },
  [theme.breakpoints.up('md')]: {
    height: 'max-content'
  },
  [theme.breakpoints.up('lg')]: {
    height: '67.3vh'
  }
}));

const AdditionalInformation = ({
  participants = [],
  setIsFormValid,
  setParticipants = () => {},
  eventData = {}
}) => {
  return (
    <>
      <StyledBox>
        <CreateAdditionalInformation
          participants={participants}
          setParticipants={setParticipants}
          setIsFormValid={setIsFormValid}
          eventData={eventData}
        />
      </StyledBox>
    </>
  );
};
export default AdditionalInformation;
